import { userForgetPasswordError } from "./reducer";

/**
 * Recuperación de contraseña: pendiente de endpoint en Kronaly API v1.
 */
export const userForgetPassword = (user, _history) => async (dispatch) => {
  dispatch(
    userForgetPasswordError(
      "La recuperación de contraseña desde la web aún no está conectada a la API."
    )
  );
};
